import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { httpService } from "~/core/http_service";

import type { UserInformation } from "../types";

export const usersKeys = {
  all: ["users"] as const,
  me: () => [...usersKeys.all, "me"] as const,
  countries: () => [...usersKeys.all, "countries"] as const,
};

const getUserInformation = (): Promise<UserInformation> => {
  return httpService.get<UserInformation>("/users/me/");
};

export const useGetUserInformation = () => {
  return useQuery<UserInformation, AxiosError>({
    queryKey: usersKeys.me(),
    queryFn: getUserInformation,
    staleTime: 60_000,
  });
};
